import React from 'react';
import { ErrorLayout } from './ErrorLayout';
import { PageMeta } from './PageMeta';
const Error404 = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PageMeta, { title: "Page Not Found" }),
        React.createElement(ErrorLayout, { title: "Page not found", errorCode: "404" },
            React.createElement("p", { className: "text-sm" },
                React.createElement("a", { href: "/", className: "link" }, "Return to Home Page")))));
};
export default Error404;
